// HUDSkinManager — loads/caches the catalogued 9:16 HUD skin frames and paints
// the phase-appropriate one as an alpha-blended bounding wrap over the canvas
// (Layer 2), beneath the DOM interactive overlays (Layer 3).

const BK = process.env.REACT_APP_BACKEND_URL;
const abs = (p) => (p ? (p.startsWith("http") ? p : BK + p) : null);

class HUDSkinManager {
  constructor() {
    this.map = null;          // { survival, arena, boss, pvp_world, slots }
    this.cache = {};          // url -> HTMLImageElement (loaded)
    this._loading = null;
  }

  async load() {
    if (this.map) return this.map;
    if (this._loading) return this._loading;
    this._loading = fetch(`${BK}/api/space/heroes/hud-skins`)
      .then((r) => (r.ok ? r.json() : {}))
      .then((m) => {
        this.map = m || {};
        Object.values(this.map).forEach((u) => u && this._img(abs(u)));
        return this.map;
      })
      .catch(() => { this.map = {}; return this.map; });
    return this._loading;
  }

  _img(url) {
    if (!url) return null;
    if (this.cache[url]) return this.cache[url];
    const im = new Image();
    im.crossOrigin = "anonymous";
    im.src = url;
    this.cache[url] = im;
    return im;
  }

  // phase: "survival" | "arena" | "boss" | "pvp_world"
  frame(phase) {
    if (!this.map) return null;
    const url = abs(this.map[phase] || this.map.survival);
    return this._img(url);
  }

  // Layer 2 draw — full-viewport wrap, zero bleed, alpha-blended.
  draw(ctx, w, h, phase, alpha = 1) {
    const im = this.frame(phase);
    if (!im || !im.complete || !im.naturalWidth) return;
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.drawImage(im, 0, 0, w, h);
    ctx.restore();
  }
}

export const hudSkins = new HUDSkinManager();
export default hudSkins;
